export default function () {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7109_11912)">
                <path
                    d="M25.3125 3.375H10.6875C9.75552 3.375 9 4.13052 9 5.0625V30.9375C9 31.8695 9.75552 32.625 10.6875 32.625H25.3125C26.2445 32.625 27 31.8695 27 30.9375V5.0625C27 4.13052 26.2445 3.375 25.3125 3.375Z"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 15.75L27 15.75" stroke="#3EAE60" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.375 9L12.375 12.375" stroke="#3EAE60" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.375 19.125L12.375 22.5" stroke="#3EAE60" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_7109_11912">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
